import React, { useEffect, useState } from "react";
import JoditEditor, { Jodit } from "jodit-react";
import { request } from "../../functions/request";
import { formatDateHourToBR } from "../../functions/functionsUtility";
import { FaSave } from "react-icons/fa";
import { toast } from "react-toastify";
import Aguarde from "../../components/aguarde/aguarde";
import { Content } from "antd/es/layout/layout";
import { Button, FloatButton, Typography } from "antd";
const { Title, Paragraph, Text, Link } = Typography;

function Tabela({ route }) {
  const [content, setContent] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const getSuffix = () => {
    return (
      route.path.split("/")[2].charAt(0).toUpperCase() +
      route.path
        .split("/")[2]
        .slice(1)
        .replace(/\//g, "")
        .replace(/_(\w)/g, (match, p1) => p1.toUpperCase())
    );
  };

  useEffect(() => {
    async function getData() {
      try {
        setIsLoading(true);
        const reqPath = `/${route.path.split("/")[2]}/get${getSuffix()}`;
        const response = await request(reqPath, {
          method: "GET",
        });

        const data = { ...response, title: route.title, path: route.path };
        setContent(data);
        setIsLoading(false);
      } catch (error) {
        console.error("Erro ao obter dados:", error);
        // Tratar o erro, se necessário.
      }
    }

    getData();
  }, [route]);

  const saveData = async () => {
    try {
      // Construindo o sufixo para operação POST com base no route.path
      const reqPath = `/${route.path.split("/")[2]}/insert${getSuffix()}`;

      const newData = { newData: { texto: content.texto } };

      const response = await request(reqPath, {
        method: "POST",
        body: JSON.stringify(newData),
      });

      if (response) {
        toast.success("Dados salvos com sucesso!");
      }
    } catch (error) {
      console.error("Erro ao salvar dados:", error);
      // Tratar o erro, se necessário.
    }
  };

  function preparePaste(jodit) {
    jodit.e.on(
      "paste",
      (e) => {
        jodit.e.stopPropagation("paste");

        const pastedHtml = Jodit.modules.Helpers.getDataTransfer(e).getData(
          Jodit.constants.TEXT_HTML
        );

        let filteredHtml = pastedHtml.replace(/&nbsp;/g, " ").replace(/=""/g, " ");

        const wrapper = document.createElement("div");
        wrapper.innerHTML = filteredHtml;
        console.log(wrapper);

        // Remove qualquer <style> existente
        const oldStyles = wrapper.querySelectorAll("style");
        oldStyles.forEach((style) => style.remove());

        const table = wrapper.querySelector("table");
        if (table) {
          // Remove todos os estilos inline (style="...") da tabela
          const allWithStyle = table.querySelectorAll("[style]");
          allWithStyle.forEach((el) => el.removeAttribute("style"));
          const rows = [...table.querySelectorAll("tr")];
          const header = rows[1];
          const years = [...header.querySelectorAll("td")].map(td =>
            td.textContent.trim()
          );

          for (let i = 2; i < rows.length; i++) {
            const cells = [...rows[i].querySelectorAll("td")];
            for (let j = 1; j < cells.length; j++) {
              const current = parseFloat(cells[j]?.textContent.replace(/\D/g, "")) || 0;
              const previous = parseFloat(cells[j + 1]?.textContent.replace(/\D/g, "")) || 0;

              let status = "neutral";
              if (current && previous) {
                if (current > previous) status = "up";
                else if (current < previous) status = "down";
              }

              let tooltip = `${years[j]} vs ${years[j + 1] || "?"}`;
              if ((status === "up" || status === "down") && previous > 0) {
                const percentDiff = (((current - previous) / previous) * 100).toFixed(1);
                tooltip += ` (${percentDiff > 0 ? "+" : ""}${percentDiff}%)`;
              }

              cells[j].setAttribute("data-status", status);
              cells[j].setAttribute("data-tooltip", tooltip);
              cells[j].classList.add("value-cell");
            }
          }


          // CSS novo que substitui qualquer <style> anterior
          const style = `
          <style>
            table { border-collapse: collapse; width: 100%; font-family: sans-serif; font-size: 14px; }
            tbody { border-radius: 8px; }
            th, td { padding: 8px 10px; text-align: right; border: 1px solid #ddd; position: relative; }
            td:first-child { text-align: left; font-weight: bold; background-color: #f4f4f4; }
            tr:nth-child(even) { background-color: #fafafa; }
            tr:hover { background-color: #f0f8ff; }
            td[data-tooltip]:hover::after {
              content: attr(data-tooltip);
              position: absolute;
              left: 100%; top: 50%;
              transform: translateY(-50%);
              background: #333; color: white;
              font-size: 12px; padding: 4px 6px;
              white-space: nowrap; border-radius: 4px;
              margin-left: 8px; z-index: 10;
            }
            td[data-status="up"] { color: green; font-weight: bold; }
            td[data-status="down"] { color: red; font-weight: bold; }
            td[data-status="neutral"] { color: gray; font-style: italic; }
          </style>
        `;

          const finalHtml = style + table.outerHTML;

          try {
            console.log("com tabela")
            jodit.s.insertHTML(finalHtml);
          } catch (error) {
            console.error("Erro ao inserir HTML:", error);
          }

          return false;
        }

        // fallback: sem tabela
        try {
          console.log("sem tabela")
          jodit.s.insertHTML(filteredHtml);
        } catch (error) {
          console.log(error);
        }

        return false;
      },
      { top: true }
    );
  }

  useEffect(() => {
    Jodit.plugins.add("preparePaste", preparePaste);
  }, []);

  return (
    <Content
      style={{
        display: "flex",
        flexDirection: "column",
        maxHeight: "100vh",
        height: "100%",
      }}
    >
      <div
        style={{
          padding: 20,
          display: "flex",
          gap: 20,
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 3,
          }}
        >
          <Title level={3} style={{ margin: 0 }}>
            {route?.title}
          </Title>
          <Text type="secondary">
            Última atualização: {formatDateHourToBR(content?.data)}
          </Text>
        </Typography>
        <Button
          type="primary"
          size="large"
          icon={<FaSave />}
          disabled={isLoading}
          onClick={saveData}
        >
          Inserir
        </Button>
      </div>
      {isLoading ? (
        <Aguarde />
      ) : (
        <Content
          style={{
            maxWidth: "1000px",
            width: "100%",
            marginInline: "auto",
            marginTop: 20,
            marginBottom: 20,
          }}
        >
          <JoditEditor
            config={{ height: "auto" }}
            value={content?.texto}
            onBlur={(newContent) => {
              const newData = { ...content, texto: newContent };
              setContent(newData);
            }}
            tabIndex={1}
          />
        </Content>
      )}
      <FloatButton.BackTop style={{ zIndex: 100 }} />
    </Content>
  );
}

export default Tabela;
